import React from 'react';
import CoverImageSecond from './CoverImageSecond';
import Service7 from './Service7';
import Service7Second from './Service7Second';



import Footer from './Footer';


const Accomadation = () => {
    return (
        <div>
            <CoverImageSecond />
            <Service7 />
            <Service7Second />


            <Footer/>

        </div>
    );
};

export default Accomadation;